import React from 'react';
import Groups from '../components/Groups';

const GroupList = () => {
    return (
        <div className="group-list-container">
            <Groups className="top-indent-md" />
        </div>
    );
};

export default GroupList;
